//import React, {Component} from 'react'
import store from './store';
import { Routes, Route, Router } from "react-router-dom";
import { Provider } from 'react-redux';

import Home from './Home';
import Items from './Items';
import UOMs from './UOMs'
import Suppliers from './Suppliers';
import Users from './Users';
import Clients from './Clients';
import Jobs from './Jobs';
import ViewUserProfile from './ViewUserProfile';

import NewItem from './NewItem';
import NewUOM from './NewUOM';
import NewSupplier from './NewSupplier';
import NewUser from './NewUser';
import RegistroNuevoUsuario from "./Register";
import NewClient from './NewClient';
import NewJob from './NewJob';
import NewCabinetFastQuote from './NewCabinetFastQuote';
import NewDoorFastQuote from './NewDoorFastQuote';
import FastQuote from './FastQuote';
import CabinetFastQuote from './CabinetFastQuote';
import DoorFastQuote from './DoorFastQuote';
import AdminSettings from './AdminSettings';

import EditItemPage from './EditItemPage'
import EditUOMPage from './EditUOMPage'
import EditSupplierPage from './EditSupplierPage'
import EditClientPage from './EditClientPage';
import EditJobsPage from './EditJobPage';
import WrapperCabinetFastQuoteVersions from './FastQuoteCabinetVersions';
import WrapperDoorFastQuoteVersions from './FastQuoteDoorVersions';
import Profile from './Profile';
import NewKitchenFastQuote from './NewKitchenFastQuote';
import Protected from './Protected';
import Login from './Login';

const MainRoutes = (props) => (   
  <>
  <Provider store={store}>
    <Routes>  
      <Route path="/">
        <Route element={<Protected />}>
          <Route exact path="/items" element={<Items />} />     
          <Route exact path="/uoms" element={<UOMs />} />     
          <Route exact path="/suppliers" element={<Suppliers />} />           
          <Route exact path="/admin-users" element={<Users />} />
          <Route exact path="/admin-settings" element={<AdminSettings />} />          
          <Route exact path="/clients" element={<Clients />} />     
          <Route exact path="/jobs" element={<Jobs />} />     
          <Route exact path="/viewuserprofile/:userid" element={<ViewUserProfile />} />

          <Route exact path="/new-item" element={<NewItem />} />

          <Route exact path="/new-supplier" element={<NewSupplier />} />
          <Route exact path="/new-user" element={<NewUser />} />
          <Route exact path="/new-client" element={<NewClient />} />
          <Route exact path="/new-uom" element={<NewUOM />} />
          <Route exact path="/new-job" element={<NewJob />} />

          <Route exact path="/fast-quote" element={<FastQuote />} /> 
          <Route exact path="/new-door-fast-quote" element={<NewDoorFastQuote mode={0} user = {props.user}/>} />          
          <Route exact path="/new-cabinet-fast-quote" element={<NewCabinetFastQuote mode={0}/>} />          
          {/*<Route exact path="/new-kitchen-fast-quote" element={<NewKitchenFastQuote mode={0} user = {props.user}/>} />          */}
          
          {/*
            create mode: mode = 0,
            edit mode: mode = 1,
            view mode: mode = 2,
          */}
          <Route exact path="/view-door-fast-quoting/:id" element={<NewDoorFastQuote mode={2} user={props.user}/>} />   
          <Route exact path="/view-cabinet-fast-quoting/:id" element={<NewCabinetFastQuote mode={2} user={props.user}/>} />   
          <Route exact path="/view-door-fast-quoting" element={<DoorFastQuote mode={2} user={props.user}/>} />   
          <Route exact path="/view-cabinet-fast-quoting" element={<CabinetFastQuote mode={2} user={props.user}/>} />   
          <Route exact path="/view-cabinet-fast-quote-versions/:id" element={<WrapperCabinetFastQuoteVersions mode={2} user={props.user}/>} />   
          <Route exact path="/view-door-fast-quote-versions/:id" element={<WrapperDoorFastQuoteVersions mode={2} user={props.user}/>} />   


          <Route exact path="/edititempage/:id" element={<EditItemPage />} />
          <Route exact path="/edituompage/:id" element={<EditUOMPage />} />
          <Route exact path="/editsupplierpage/:id" element={<EditSupplierPage />} />
          <Route exact path="/editclientpage/:id" element={<EditClientPage />} />
          <Route exact path="/editjobpage/:id" element={<EditJobsPage />} />
          <Route exact path="/edit-kitchen-fast-quote/:id" element={<NewKitchenFastQuote mode={1}/>} />          

          <Route exact path='/userprofile' element={<Profile/>} />

        </Route>
        {/* public routes */}
        <Route exact path="/new-kitchen-fast-quote" element={<NewKitchenFastQuote mode={0}/>} />          
        <Route exact path="/login/*" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="auto-register" element={<RegistroNuevoUsuario />} />
        <Route path="*" element={<h1>Page not found</h1>} />        

      </Route>

    </Routes>
  </Provider>
  </>
);

export default MainRoutes;

